module.exports = Ember.Application.create({
  rootElement: '#application',
  LOG_TRANSITIONS: true
});
